<template>
  <div class="contact" id="contact">
    <div class="alert-show" v-if="sent!==null"><span>{{sent}}</span></div>
    <div class="container">
      <h1 class="section-title">{{state.translation.contact.title}}</h1>
      <div class="border-cust"></div>
      <div class="row d-flex align-items-center">
        <div class="col-12 col-lg-6 left">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <h2><span class="margin-icon"><awesome-icon class="icon-contact" :icon="['fas', 'map-marker-alt']"></awesome-icon></span> {{state.translation.contact.address}}</h2>
                  <h3 class="mt-5"><span class="margin-p"></span><span v-html="state.translation.contact.addressInfo"></span></h3>
                </div>
              </div>
            </div>
            <div class="col-12 mt-5 pt-5">
              <div class="row">
                <div class="col-12">
                  <h2><span class="margin-icon"><awesome-icon class="icon-contact" :icon="['fas', 'phone-alt']"></awesome-icon></span> {{state.translation.contact.talk}}</h2>
                  <h3 class="mt-5"><span class="margin-p"></span><a href="tel:+381603951707">+381 60 3951707</a></h3>
                </div>
              </div>
            </div>
            <div class="col-12 mt-5 pt-5">
              <div class="row">
                <div class="col-12">
                  <h2><span class="margin-icon"><awesome-icon class="icon-contact" :icon="['far', 'envelope']"></awesome-icon></span> {{state.translation.contact.gsupport}}</h2>
                  <h3 class="mt-5"><span class="margin-p"></span><a href="mailto:client@it-fortress.com">client@it-fortress.com</a></h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 right">
            <div class="contact-form">
              <div class="text-center">
                <span class="contact-form-env position-absolute"><awesome-icon class="icon-contact-form" :icon="['far', 'envelope']"></awesome-icon></span>
              </div>
              <h2>{{state.translation.contact.form.title}}</h2>
              <form>
                  <p>{{state.translation.contact.form.email}}</p>
                  <input :class="[{'error': emailError}]" type="email" required autocomplete name="email" v-model="email" :placeholder="state.translation.contact.form.emailPl">
                  <p>{{state.translation.contact.form.name}}</p>
                  <input :class="[{'error': nameError}]" type="text" required autocomplete name="name" v-model="name" :placeholder="state.translation.contact.form.namePl">
                  <p>{{state.translation.contact.form.message}}</p>
                  <textarea :class="[{'error': messageError}]" required autocomplete name="message" v-model="message" :placeholder="state.translation.contact.form.messagePl"></textarea>
                  <input type="button" name="submit" @click="doSubmit()" :value="state.translation.contact.form.button">
              </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      name: null,
      nameError: false,
      email: null,
      emailError: false,
      message: null,
      messageError: false,
      state: this.$root.$data.state,
      sent: null
    }
  },
  methods: {
    validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return (true)
      }
      return (false)
      },
      doSubmit() {

        this.nameError = false;
        this.emailError = false;
        this.messageError = false;
        this.sent = null;

        if (!this.name || this.name == '') {
          this.nameError = true;
        }

        if (!this.email || this.email == '' || !this.validateEmail(this.email)) {
          this.emailError = true;
        }

        if (!this.message || this.message == '') {
          this.messageError = true;
        }

        if (this.nameError || this.emailError || this.messageError) {
          return;
        }

        this.submit(this.name, this.email, this.message)
          .then((resp) => {
            let data = resp.data;
            if (data==1) {
              this.sent = 'Message has been sent.';
              this.name = null;
              this.email = null;
              this.message = null;
            } else {
              this.sent = 'There was an error while sending message. Please try again later.';
            }
          });

      }
  },
  watch: {
      'sent': function() {
        let self = this;
        setTimeout(() => {self.sent = null;}, 5000)
      },
  }
}
</script>
